/** Content identity keeps unrelated insertions from remounting answer chips.
 * Identical repeated parts still need distinct sibling keys; only those
 * duplicates share an occurrence counter, never the overall array position. */
export function keyedAnswerParts<T>(
  values: readonly T[],
  identity: (value: T) => string
): Array<{ key: string; value: T }> {
  const occurrences = new Map<string, number>();
  return values.map((value) => {
    const content = identity(value);
    const occurrence = occurrences.get(content) ?? 0;
    occurrences.set(content, occurrence + 1);
    return { key: JSON.stringify([content, occurrence]), value };
  });
}
